module.exports = __webpack_public_path__ + "static/media/AlertCircle.616cacea.svg";